import React from 'react';
import { Link } from 'react-router-dom';
import IntroSection from '../components/sections/IntroSection';
import './PageLayout.css';

const AboutPage = () => {
  return (
    <div className="page-layout">
      <Link to="/" className="back-button">← Home</Link>
      <div className="page-content">
        <IntroSection />
      </div>
    </div>
  );
};

export default AboutPage;

